export default [
  { name: "خانه", link: "/" },
  {
    name: "راهنما",
    link: "https://behamrah.b-test.ir/howitworks",
    isExternal: true,
  },
  { name: "پیشنهاد مسیر", link: "/survey" },
  {
    name: "سوالات متداول",
    link: "https://behamrah.b-test.ir/faq",
    isExternal: true,
  },
  {
    name: "پشتیبانی",
    link: "https://behamrah.b-test.ir/support",
    isExternal: true,
  },
];
